import type { SVGProps } from 'react';

export const VisaLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="32" height="32" rx="4" fill="#1434CB"/>
    <path d="M12.96 22L14.88 10H17.84L15.92 22H12.96ZM24.44 10.36C23.88 10.12 23.08 9.96 22.08 9.96C19.2 9.96 17.2 11.52 17.16 13.72C17.12 15.32 18.6 16.2 19.68 16.76C20.8 17.32 21.16 17.68 21.16 18.2C21.16 19 20.24 19.36 19.28 19.36C18.08 19.36 17.4 19.04 16.88 18.76L16.48 18.52L16.04 21.28C16.64 21.56 17.72 21.84 18.88 21.84C21.96 21.84 23.96 20.28 24 18.04C24 16 22.56 15 21.56 14.48C20.56 13.96 19.92 13.64 19.92 13.08C19.92 12.56 20.52 12.16 21.48 12.16C22.28 12.12 22.92 12.32 23.4 12.52L23.72 12.68L24.44 10.36ZM11.4 10H8.32C7.72 10 7.32 10.28 7.08 10.84L4 22H7.04L7.64 20.28H11.36L11.72 22H14.4L11.4 10ZM8.44 18.08L9.92 13.88L10.76 18.08H8.44ZM28.52 10H26C25.4 10 24.96 10.32 24.68 10.84L20.84 22H23.96L24.56 20.28H28.28L28.64 22H31.32L28.52 10ZM25.36 18.08L26.84 13.88L27.68 18.08H25.36Z" fill="white"/>
  </svg>
);

export const MastercardLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="11.5" cy="16" r="9.5" fill="#EB001B"/>
    <circle cx="20.5" cy="16" r="9.5" fill="#F79E1B"/>
    <path d="M16 21.53C17.38 20.15 18.25 18.17 18.25 16C18.25 13.83 17.38 11.85 16 10.47C14.62 11.85 13.75 13.83 13.75 16C13.75 18.17 14.62 20.15 16 21.53Z" fill="#FF5F00"/>
  </svg>
);

export const AmexLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="32" height="32" rx="4" fill="#002663"/>
    <path d="M22.03 21H17.43L15.93 16.63H13.68L12.15 21H10.15L7.65 13H10.2L11.5 17.2L12.95 13H15L16.48 17.2L17.78 13H20.28L17.78 21H20.03L22.03 21Z" fill="white"/>
    <path d="M23.33 21V13H27.93V14.88H25.33V16H27.58V17.88H25.33V19.13H27.93V21H23.33Z" fill="white"/>
  </svg>
);

export const GenericCardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
    <line x1="1" y1="10" x2="23" y2="10"></line>
  </svg>
);

export const BrandIcon = ({ brand, className }: { brand: string, className?: string }) => {
  switch (brand) {
    case 'visa':
      return <VisaLogo className={className} />;
    case 'mastercard':
      return <MastercardLogo className={className} />;
    case 'amex':
      return <AmexLogo className={className} />;
    default:
      return <GenericCardIcon className={className} style={{ width: '1.5rem', height: '1.5rem', opacity: 0.5 }} />;
  }
};
